module.exports = __webpack_public_path__ + "img/demo_image_02.5839a917.png";